/**
 * InfoBadge renders a colored badge based on discount/upcharge.
 * @param {object} props
 * @param {string} props.text
 * @param {"discount"|"upcharge"} props.type
 */
export default function InfoBadge({ text, type }) {
  if (!text) return null;
  let colorClasses = type === "discount"
    ? "text-blue-500 border-blue-200 bg-blue-50"
    : type === "upcharge"
      ? "text-orange-600 border-orange-200 bg-orange-50"
      : "";
  return <span className={`text-xs border rounded-lg px-2 py-1 ${colorClasses}`}>{text}</span>;
}
